import { LandingPage } from './LandingPage'

export const LandingRoute = {
  path: '/landing',
  element: <LandingPage />,
}
